import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPersonalProtectiveEquipmentList,
	addNewPersonalProtectiveEquipment,
	updatePersonalProtectiveEquipment,
	deletePersonalProtectiveEquipment,
	getPersonalProtectiveEquipment,
	setPersonalProtectiveEquipmentCancelled,
	setPersonalProtectiveEquipmentDelivered,
	setPersonalProtectiveEquipmentPicked,
	getPersonalProtectiveEquipmentByPersonId,
	getPersonalProtectiveEquipmentStatusByCode,
	getPersonalProtectiveEquipmentReasonList,
	getDashboardStatus,
	getDashboardReason,
	getDashboardEstablishment,
	getDashboardCompany,
	getAssignedItemsList,
	getPersonAssignedItemsSummary,
	getPersonAssignedItemsSummaryAll,
	getWarehouseAssignedItemsSummary,
	getPersonalProtectiveEquipmentStatusDefaultRegularization,
} from '../personalProtectiveEquipment/thunk';

export const initialState = {
	itemPersonalProtectiveEquipmentList: [],
	dashboardStatus: [],
	dashboardReason: [],
	dashboardEstablishment: [],
	dashboardCompany: [],
	dashboardAssignedItems: [],
	itemPersonalProtectiveEquipmentDetail: null,
	isPersonalProtectiveEquipmentLoading: false,
	isPersonalProtectiveEquipmentSuccess: false,

	personalProtectiveEquipmentList: [],
	personalProtectiveEquipmentListSelect: [],
	isLoadingList: false,


	
	isLoadingDashboardStatus: false,
	isLoadingDashboardReason: false,
	isLoadingDashboardEstablishment: false,
	isLoadingDashboardCompany: false,
	isLoadingDashboardAssignedItems: false,


	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	
	personalProtectiveEquipmentStatusDefaultRegularization: null,
	isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading: false,
	isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess: false,
};

const PersonalProtectiveEquipmentSlice = createSlice({
	name: 'PersonalProtectiveEquipments',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		setPersonalProtectiveEquipmentStatusDefaultRegularization(state, action) {
			state.personalProtectiveEquipmentStatusDefaultRegularization = action.payload;
		},
		updateDocumentId(state, action) {
			const { ppeId, documentId } = action.payload;

			const item = state.itemPersonalProtectiveEquipmentList.find(
				(item) => item._id === ppeId
			);

			if (item) {
				item.document_id = documentId;
			}
		},
	},
	extraReducers: builder => {
		builder.addCase(getPersonalProtectiveEquipment.fulfilled, (state, action) => {
			state.isPersonalProtectiveEquipmentLoading = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.itemPersonalProtectiveEquipmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPersonalProtectiveEquipment.pending, state => {
			state.isPersonalProtectiveEquipmentLoading = true;
			state.isPersonalProtectiveEquipmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonalProtectiveEquipment.rejected, (state, action) => {
			state.isPersonalProtectiveEquipmentLoading = false;
			state.isPersonalProtectiveEquipmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getPersonalProtectiveEquipmentList.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentList.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = action.payload;
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;

			let personalProtectiveEquipmentListSelect = [];
			action.payload.map(item =>
				personalProtectiveEquipmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.personalProtectiveEquipmentListSelect = personalProtectiveEquipmentListSelect;
		});
		builder.addCase(getPersonalProtectiveEquipmentList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});



		builder.addCase(getPersonalProtectiveEquipmentByPersonId.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentByPersonId.fulfilled, (state, action) => {
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentByPersonId.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(addNewPersonalProtectiveEquipment.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList.push(action.payload);
			state.personalProtectiveEquipmentList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPersonalProtectiveEquipment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPersonalProtectiveEquipment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePersonalProtectiveEquipment.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = current(state.itemPersonalProtectiveEquipmentList).map(personalProtectiveEquipment =>
				personalProtectiveEquipment._id === action.payload._id
					? { ...personalProtectiveEquipment, ...action.payload }
					: personalProtectiveEquipment
			);
			state.personalProtectiveEquipmentList = current(state.personalProtectiveEquipmentList).map(personalProtectiveEquipment =>
				personalProtectiveEquipment._id === action.payload._id
					? { ...personalProtectiveEquipment, ...action.payload }
					: personalProtectiveEquipment
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePersonalProtectiveEquipment.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(updatePersonalProtectiveEquipment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
			state.requireCloseModal = false;
		});

		builder.addCase(deletePersonalProtectiveEquipment.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = current(state.itemPersonalProtectiveEquipmentList).filter(
				item => item._id !== action.payload._id
			);
			state.personalProtectiveEquipmentList = current(state.personalProtectiveEquipmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePersonalProtectiveEquipment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePersonalProtectiveEquipment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});


		builder.addCase(setPersonalProtectiveEquipmentCancelled.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = current(state.itemPersonalProtectiveEquipmentList).filter(
				item => item._id !== action.payload._id
			);
			state.personalProtectiveEquipmentList = current(state.personalProtectiveEquipmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isUpdated = true;
			state.requireCloseModal = true;
			state.isLoadingList = false;
		});
		builder.addCase(setPersonalProtectiveEquipmentCancelled.pending, (state, action) => {
			state.isUpdated = null;
			state.isLoadingList = true;
		});
		builder.addCase(setPersonalProtectiveEquipmentCancelled.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdated = false;
		});


		builder.addCase(setPersonalProtectiveEquipmentDelivered.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = current(state.itemPersonalProtectiveEquipmentList).filter(
				item => item._id !== action.payload._id
			);
			state.personalProtectiveEquipmentList = current(state.personalProtectiveEquipmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isUpdated = true;
			state.requireCloseModal = true;
			state.isLoadingList = false;
		});
		builder.addCase(setPersonalProtectiveEquipmentDelivered.pending, (state, action) => {
			state.isUpdated = null;
			state.isLoadingList = true;
		});
		builder.addCase(setPersonalProtectiveEquipmentDelivered.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdated = false;
		});

		
		builder.addCase(setPersonalProtectiveEquipmentPicked.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentDetail = action.payload;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(setPersonalProtectiveEquipmentPicked.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(setPersonalProtectiveEquipmentPicked.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});


		builder.addCase(getPersonalProtectiveEquipmentStatusByCode.fulfilled, (state, action) => {
			state.isPersonalProtectiveEquipmentLoading = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.itemPersonalProtectiveEquipmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getPersonalProtectiveEquipmentStatusByCode.pending, state => {
			state.isPersonalProtectiveEquipmentLoading = true;
			state.isPersonalProtectiveEquipmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentStatusByCode.rejected, (state, action) => {
			state.isPersonalProtectiveEquipmentLoading = false;
			state.isPersonalProtectiveEquipmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});


		builder.addCase(getPersonalProtectiveEquipmentReasonList.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentReasonList.fulfilled, (state, action) => {
			state.itemPersonalProtectiveEquipmentList = action.payload;
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;

			let personalProtectiveEquipmentListSelect = [];
			action.payload.map(item =>
				personalProtectiveEquipmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.personalProtectiveEquipmentListSelect = personalProtectiveEquipmentListSelect;
		});
		builder.addCase(getPersonalProtectiveEquipmentReasonList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});



		

		builder.addCase(getDashboardStatus.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingDashboardStatus = true;
		});
		builder.addCase(getDashboardStatus.fulfilled, (state, action) => {
			state.dashboardStatus = action.payload; 
			state.isLoadingDashboardStatus = false;
			state.isPersonalProtectiveEquipmentSuccess = true; 
		});
		builder.addCase(getDashboardStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingDashboardStatus = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});

		builder.addCase(getDashboardReason.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingDashboardReason = true;
		});
		builder.addCase(getDashboardReason.fulfilled, (state, action) => {
			state.dashboardReason = action.payload; 
			state.isLoadingDashboardReason = false;
			state.isPersonalProtectiveEquipmentSuccess = true; 
		});
		builder.addCase(getDashboardReason.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingDashboardReason = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(getDashboardEstablishment.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingDashboardEstablishment = true;
		});
		builder.addCase(getDashboardEstablishment.fulfilled, (state, action) => {
			state.dashboardEstablishment = action.payload; 
			state.isLoadingDashboardEstablishment = false;
			state.isPersonalProtectiveEquipmentSuccess = true; 
		});
		builder.addCase(getDashboardEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingDashboardEstablishment = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(getDashboardCompany.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingDashboardCompany = true;
		});
		builder.addCase(getDashboardCompany.fulfilled, (state, action) => {
			state.dashboardCompany = action.payload; 
			state.isLoadingDashboardCompany = false;
			state.isPersonalProtectiveEquipmentSuccess = true; 
		});
		builder.addCase(getDashboardCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingDashboardCompany = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(getAssignedItemsList.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingDashboardAssignedItems = true;
		});
		builder.addCase(getAssignedItemsList.fulfilled, (state, action) => {
			state.dashboardAssignedItems = action.payload; 
			state.isLoadingDashboardAssignedItems = false;
			state.isPersonalProtectiveEquipmentSuccess = true; 
		});
		builder.addCase(getAssignedItemsList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingDashboardAssignedItems = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});



		builder.addCase(getPersonAssignedItemsSummary.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonAssignedItemsSummary.fulfilled, (state, action) => { 
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;  
		});
		builder.addCase(getPersonAssignedItemsSummary.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});



		builder.addCase(getPersonAssignedItemsSummaryAll.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPersonAssignedItemsSummaryAll.fulfilled, (state, action) => { 
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;  
		});
		builder.addCase(getPersonAssignedItemsSummaryAll.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(getWarehouseAssignedItemsSummary.pending, state => {
			state.isPersonalProtectiveEquipmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWarehouseAssignedItemsSummary.fulfilled, (state, action) => { 
			state.personalProtectiveEquipmentList = action.payload;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;  
		});
		builder.addCase(getWarehouseAssignedItemsSummary.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPersonalProtectiveEquipmentSuccess = true;
		});


		builder.addCase(getPersonalProtectiveEquipmentStatusDefaultRegularization.pending, state => {
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading = true;
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess = false;
		});
		builder.addCase(getPersonalProtectiveEquipmentStatusDefaultRegularization.fulfilled, (state, action) => {
			state.personalProtectiveEquipmentStatusDefaultRegularization = action.payload[0];
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading = false;
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess = true;
		});
		builder.addCase(getPersonalProtectiveEquipmentStatusDefaultRegularization.rejected, (state, action) => {
			state.error = action.payload || null;
			state.personalProtectiveEquipmentStatusDefaultRegularization = null;
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationLoading = false;
			state.isPersonalProtectiveEquipmentStatusDefaultRegularizationSuccess = false;
		});

	},
});

export const {
	setRequireCloseModal,
	setPersonalProtectiveEquipmentStatusDefaultRegularization,
	updateDocumentId
} = PersonalProtectiveEquipmentSlice.actions;

export default PersonalProtectiveEquipmentSlice.reducer;
